import { initializeApp, getApps } from 'firebase/app';
import { getMessaging, getToken, isSupported } from 'firebase/messaging';
import { get, post } from '../functions';

let runningPromise = null;
let pushConfigPromise = null;

const getPushConfig = async () => {
    if (pushConfigPromise) {
        return pushConfigPromise;
    }

    pushConfigPromise = (async () => {
        const response = await get('/api/me/push-config');
        if (!response || response.status !== 'ok' || !response.enabled || !response.firebase || !response.vapidKey) {
            return null;
        }
        return response;
    })().catch(() => {
        pushConfigPromise = null;
        return null;
    });

    return pushConfigPromise;
};

export const registerWebPushNotifications = async () => {
    if (runningPromise) {
        return runningPromise;
    }

    runningPromise = (async () => {
        if (typeof window === 'undefined' || typeof Notification === 'undefined' || !('serviceWorker' in navigator)) {
            return false;
        }

        const pushConfig = await getPushConfig();
        if (!pushConfig) {
            return false;
        }

        const supported = await isSupported();
        if (!supported) {
            return false;
        }

        const params = new URLSearchParams({
            apiKey: pushConfig.firebase.apiKey,
            authDomain: pushConfig.firebase.authDomain,
            projectId: pushConfig.firebase.projectId,
            storageBucket: pushConfig.firebase.storageBucket,
            messagingSenderId: pushConfig.firebase.messagingSenderId,
            appId: pushConfig.firebase.appId,
            measurementId: pushConfig.firebase.measurementId
        });
        const swUrl = `/firebase-messaging-sw.js?${params.toString()}`;
        const registration = await navigator.serviceWorker.register(swUrl);

        let permission = Notification.permission;
        if (permission !== 'granted') {
            permission = await Notification.requestPermission();
        }

        if (permission !== 'granted') {
            return false;
        }

        const app = getApps().length ? getApps()[0] : initializeApp(pushConfig.firebase);
        const messaging = getMessaging(app);

        const token = await getToken(messaging, {
            vapidKey: pushConfig.vapidKey,
            serviceWorkerRegistration: registration
        });

        if (!token) {
            return false;
        }

        const response = await post('/api/me/push-token', { token });
        return response?.status === 'ok';
    })().catch((error) => {
        runningPromise = null;
        return false;
    });

    return runningPromise;
};
